// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iK0H","tabsBox":"styles_tabsBox__3qoNU","createButton":"styles_createButton__dvfmL"};